module.exports = __webpack_public_path__ + "static/dcruvolo-16a2e1e5e48ba95aed1c754fd7fd0d57.jpeg";